export function Footer() {
  return (
    <footer className="site-footer" role="contentinfo">
      <div className="container site-footer-row">
        <span>© 2026 N801 Studio</span>
        <span>All rights reserved</span>
      </div>
    </footer>
  );
}
